import { Link } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import React from 'react';
import styled from 'styled-components';
import { PostTitle } from './PostTitle';
import { Subline } from './Subline';

const Post = styled.article`
  display: flex;
  flex-direction: column;
  padding: 3.5rem 2rem;
`;

const Initiale = styled.span`
  position: absolute;
  font-size: 7rem;
  transform: translate(-50%, -50%);
  opacity: 0.08;
  user-select: none;
  z-index: -1;
`;

const Excerpt = styled.p`
  grid-column: -1 / 1;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

interface Props {
  title: string;
  date: string;
  excerpt: string;
  slug: string;
  timeToRead: number;
  category: string;
}

export class Article extends React.PureComponent<Props> {
  public render() {
    const { title, date, excerpt, slug, timeToRead } = this.props;
    const firstChar = title.charAt(0);

    return (
      <Post>
        <PostTitle>
          <Initiale>{firstChar}</Initiale>
          <Link className='telia-article-list-title' to={`/blog/${slug}`}>{title}</Link>
        </PostTitle>
        <Subline>
          {date} &mdash; {timeToRead} Min Read
        </Subline>
        <Excerpt>{excerpt}</Excerpt>
      </Post>
    );
  }
}
